import DotNetObject = DotNet.DotNetObject;
import { Vendor } from '@crimsontide/core/client/interfaces';
import { VendorProduct } from '@crimsontide/core/client/interfaces';

export const VendorService = (() => {
  let dotNetObj: DotNetObject;
  let cachedVendors: Vendor[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getVendors = async (useCache: boolean = true): Promise<Vendor[]> => {
    if (useCache && cachedVendors != null)
      return cachedVendors;

    if (dotNetObj) {
      cachedVendors = await dotNetObj.invokeMethodAsync<Vendor[]>('GetAsync');
      return cachedVendors;
    } else {
      throw 'Vendor DotNet Object Reference has not yet been implemented';
    }
  };

  const getVendorProducts = async (
    customerId: string,
    siteId: string,
    productId: string
  ): Promise<VendorProduct[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<VendorProduct[]>
      (
        'GetVendorProductsAsync',
        customerId,
        siteId,
        productId
      );
    } else {
      throw 'Vendor DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getVendors,
    getVendorProducts,
  };
})();
